import { Component } from '@angular/core';
import {HeaderComponent} from "../../header/header.component";
import {FooterComponent} from "../../footer/footer.component";
import {Router} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'vex-terms-conditions',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss'
})
export class TermsConditionsComponent {
  constructor(private router: Router,
              private title : Title,
              private meta : Meta,) {
  }
  ngOnInit() {
    this.updateMetaTags()
  }
  goTo(url) {
    this.router.navigateByUrl(url);
  }

  updateMetaTags() {
    this.title.setTitle('Learn More About Our Policies, Enroll Terms and Conditions');
    this.meta.updateTag({name: 'description', content: `Read the Enroll terms and conditions to understand our policies and guidelines. Ensure a smooth experience with Volmint’s admission management software.`});
  }
}
